module.exports = __webpack_public_path__ + "static/media/map-marker.657887fa.svg";